module.exports = __webpack_public_path__ + "img/25800.cbdb8fe4.jpg";